import { useState ,useRef, useEffect  } from "react";

import moto from "../../media/honda-motor-company-scooter-1.png";
import "./HotspotsMoto.scss";

const HotspotsMoto = () => {
  const [activeSpot, setActiveSpot] = useState(null);
  const containerRef = useRef(null);
  const tooltipRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });



  const spots = [
    { id: 1, top: "54%", left: "27%", title: "Zawieszenie", text: "Serwis uszczelniaczy, regulacja tłumienia i geometrii – komfort jazdy i stabilność na nierównościach." },
    { id: 5, top: "75%", left: "25%", title: "Układ hamulcowy ", text: "Serwis klocków, tarcz i płynu hamulcowego; gwarancja skutecznego zatrzymania w nagłych sytuacjach." },
    { id: 6, top: "64%", left: "14%", title: "Opony i koła", text: "Wymiana, wyważanie i kontrola ciśnienia. Pewna przyczepność, krótsza droga hamowania, większe bezpieczeństwo w zakrętach." },
    { id: 7, top: "74%", left: "77%", title: "Napęd (łańcuch / zębatki) ", text: "Czyszczenie, smarowanie i ustawianie naciągu – dłuższa żywotność napędu, płynne przekazywanie mocy." },
    { id: 2, top: "65%", left: "46%", title: "Silnik", text: "Diagnostyka, regulacja zaworów, wymiana oleju, serwis układu chłodzenia." },
    { id: 3, top: "51%", left: "41%", title: "Lakierowanie", text: "Profesjonalne lakierowanie elementów i całych motocykli – renowacja, personalizacja i ochrona przed korozją." },
    { id: 4, top: "21%", left: "39%", title: "Elektryka", text: "Test akumulatora, instalacji i stacyjki; zapobieganie problemom z odpalaniem i usterkom w trasie." }
  ];

  const currentSpot = spots.find(s => s.id === activeSpot);

useEffect(() => {
  if (!tooltipRef.current || !containerRef.current || !currentSpot) return;

  const containerRect = containerRef.current.getBoundingClientRect();
  const tooltipRect = tooltipRef.current.getBoundingClientRect();

  // початкова позиція hotspot у px
  const topPx =
    (parseFloat(currentSpot.top) / 100) * containerRect.height;
  const leftPx =
    (parseFloat(currentSpot.left) / 100) * containerRect.width;

  let top = topPx - tooltipRect.height - 12;
  let left = leftPx - tooltipRect.width / 2;

  const padding = 10;

  // межі контейнера
  if (left < padding) left = padding;
  if (left + tooltipRect.width > containerRect.width - padding) {
    left = containerRect.width - tooltipRect.width - padding;
  }

  if (top < padding) {
    top = topPx + 20; // показуємо знизу, якщо зверху не влазить
  }

  setTooltipPos({ top, left });
}, [currentSpot]);



  return (
    <div className="moto-container" ref={containerRef}>
      <img src={moto} className="moto-image" alt="moto" />

      {spots.map(spot => (
        <div
          key={spot.id}
          className="hotspot"
          style={{ top: spot.top, left: spot.left }}
          onMouseEnter={() => setActiveSpot(spot.id)}
          onMouseLeave={() => setActiveSpot(null)}
        >
          <span className="dot" />
        </div>
      ))}

    {currentSpot && (
      <div
        ref={tooltipRef}
        className="tooltip"
        style={{
          top: `${tooltipPos.top}px`,
          left: `${tooltipPos.left}px`
        }}
      >
        <strong>{currentSpot.title}</strong>
        <p>{currentSpot.text}</p>
      </div>
    )}
    </div>

  );
};

export default HotspotsMoto;
